<template>
  <svg width="100"
       height="100"
       viewBox="0 0 100 100"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M36.6875 4.6875H63.3125C66.4062 4.6875 69.3438 5.90625 71.5312 8.09375L90.3438 26.9062C92.5313 29.0938 93.75 32.0312 93.75 35.125V61.75C93.75 64.8438 92.5313 67.7812 90.3438 69.9688L71.5312 88.7812C69.3438 90.9688 66.4062 92.1875 63.3125 92.1875H36.6875C33.5938 92.1875 30.6563 90.9688 28.4688 88.7812L9.65624 69.9688C7.46874 67.7812 6.25 64.8438 6.25 61.75V35.125C6.25 32.0312 7.46874 29.0938 9.65624 26.9062L28.4688 8.09375C30.6563 5.90625 33.5938 4.6875 36.6875 4.6875Z"
          fill="url(#paint0_linear_8778_59763)"
    />
    <path d="M36.6875 4.6875H63.3125C66.4062 4.6875 69.3438 5.90625 71.5312 8.09375L90.3438 26.9062C92.5313 29.0938 93.75 32.0312 93.75 35.125V61.75C93.75 64.8438 92.5313 67.7812 90.3438 69.9688L71.5312 88.7812C69.3438 90.9688 66.4062 92.1875 63.3125 92.1875H36.6875C33.5938 92.1875 30.6563 90.9688 28.4688 88.7812L9.65624 69.9688C7.46874 67.7812 6.25 64.8438 6.25 61.75V35.125C6.25 32.0312 7.46874 29.0938 9.65624 26.9062L28.4688 8.09375C30.6563 5.90625 33.5938 4.6875 36.6875 4.6875Z"
          fill="url(#paint1_linear_8778_59763)"
    />
    <path d="M36.6875 4.6875H63.3125C66.4062 4.6875 69.3438 5.90625 71.5312 8.09375L90.3438 26.9062C92.5313 29.0938 93.75 32.0312 93.75 35.125V61.75C93.75 64.8438 92.5313 67.7812 90.3438 69.9688L71.5312 88.7812C69.3438 90.9688 66.4062 92.1875 63.3125 92.1875H36.6875C33.5938 92.1875 30.6563 90.9688 28.4688 88.7812L9.65624 69.9688C7.46874 67.7812 6.25 64.8438 6.25 61.75V35.125C6.25 32.0312 7.46874 29.0938 9.65624 26.9062L28.4688 8.09375C30.6563 5.90625 33.5938 4.6875 36.6875 4.6875Z"
          fill="url(#paint2_linear_8778_59763)"
    />
    <path d="M36.6875 4.6875H63.3125C66.4062 4.6875 69.3438 5.90625 71.5312 8.09375L90.3438 26.9062C92.5313 29.0938 93.75 32.0312 93.75 35.125V61.75C93.75 64.8438 92.5313 67.7812 90.3438 69.9688L71.5312 88.7812C69.3438 90.9688 66.4062 92.1875 63.3125 92.1875H36.6875C33.5938 92.1875 30.6563 90.9688 28.4688 88.7812L9.65624 69.9688C7.46874 67.7812 6.25 64.8438 6.25 61.75V35.125C6.25 32.0312 7.46874 29.0938 9.65624 26.9062L28.4688 8.09375C30.6563 5.90625 33.5938 4.6875 36.6875 4.6875Z"
          fill="url(#paint3_linear_8778_59763)"
    />
    <path d="M36.6875 4.6875H63.3125C66.4062 4.6875 69.3438 5.90625 71.5312 8.09375L90.3438 26.9062C92.5313 29.0938 93.75 32.0312 93.75 35.125V61.75C93.75 64.8438 92.5313 67.7812 90.3438 69.9688L71.5312 88.7812C69.3438 90.9688 66.4062 92.1875 63.3125 92.1875H36.6875C33.5938 92.1875 30.6563 90.9688 28.4688 88.7812L9.65624 69.9688C7.46874 67.7812 6.25 64.8438 6.25 61.75V35.125C6.25 32.0312 7.46874 29.0938 9.65624 26.9062L28.4688 8.09375C30.6563 5.90625 33.5938 4.6875 36.6875 4.6875Z"
          fill="url(#paint4_linear_8778_59763)"
    />
    <path d="M36.6875 4.6875H63.3125C66.4062 4.6875 69.3438 5.90625 71.5312 8.09375L90.3438 26.9062C92.5313 29.0938 93.75 32.0312 93.75 35.125V61.75C93.75 64.8438 92.5313 67.7812 90.3438 69.9688L71.5312 88.7812C69.3438 90.9688 66.4062 92.1875 63.3125 92.1875H36.6875C33.5938 92.1875 30.6563 90.9688 28.4688 88.7812L9.65624 69.9688C7.46874 67.7812 6.25 64.8438 6.25 61.75V35.125C6.25 32.0312 7.46874 29.0938 9.65624 26.9062L28.4688 8.09375C30.6563 5.90625 33.5938 4.6875 36.6875 4.6875Z"
          fill="url(#paint5_linear_8778_59763)"
    />
    <path d="M39.2812 10.9375H60.7187C63.8125 10.9375 66.75 12.1562 68.9375 14.3437L84.0938 29.5C86.2813 31.6875 87.5 34.625 87.5 37.7188V59.1562C87.5 62.25 86.2813 65.1875 84.0938 67.375L68.9375 82.5312C66.75 84.7188 63.8125 85.9375 60.7187 85.9375H39.2812C36.1875 85.9375 33.25 84.7188 31.0625 82.5312L15.9062 67.375C13.7187 65.1875 12.5 62.25 12.5 59.1562V37.7188C12.5 34.625 13.7187 31.6875 15.9062 29.5L31.0625 14.3437C33.25 12.1562 36.1875 10.9375 39.2812 10.9375Z"
          fill="url(#paint6_linear_8778_59763)"
    />
    <defs>
      <linearGradient id="paint0_linear_8778_59763"
                      x1="87.0628"
                      y1="20.2349"
                      x2="27.6586"
                      y2="84.6633"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBF9FC" />
        <stop offset="0.50095"
              stop-color="#D5C9DD"
        />
        <stop offset="1"
              stop-color="#B9B3BC"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_8778_59763"
                      x1="50"
                      y1="97.1199"
                      x2="50"
                      y2="84.8544"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8C749B" />
        <stop offset="1"
              stop-color="#8C749B"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_8778_59763"
                      x1="17.1875"
                      y1="76.5625"
                      x2="78.125"
                      y2="15.625"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.0424679"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_8778_59763"
                      x1="6.25"
                      y1="48.4375"
                      x2="93.75"
                      y2="48.4375"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.0424679"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_8778_59763"
                      x1="18.75"
                      y1="17.1875"
                      x2="81.25"
                      y2="78.125"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.043756"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_8778_59763"
                      x1="50"
                      y1="1.5625"
                      x2="50"
                      y2="92.1875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#928F95" />
        <stop offset="0.0668103"
              stop-color="#928F95"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_8778_59763"
                      x1="90.9943"
                      y1="48.4375"
                      x2="12.4941"
                      y2="48.4375"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E53146" />
        <stop offset="1"
              stop-color="#CC307A"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
